export default "__VITE_ASSET__CRJWl$fB__"